import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LashLiftLanding from "@/pages/LashLiftLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LashLiftLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#0e0e0e',
            color: '#fff',
            border: '1px solid #c9a96e',
            fontFamily: 'Manrope, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
